module.exports = __webpack_public_path__ + "img/btn04.b00818af.png";